import { render, staticRenderFns } from "./deliveryRecord.vue?vue&type=template&id=651f6467&scoped=true"
import script from "./deliveryRecord.vue?vue&type=script&lang=js"
export * from "./deliveryRecord.vue?vue&type=script&lang=js"
import style0 from "./deliveryRecord.vue?vue&type=style&index=0&id=651f6467&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f6467",
  null
  
)

export default component.exports